import React from "react";
import { useTranslation } from "react-i18next";
import { Dropdown, Button, theme } from "antd";
import { GlobalOutlined } from "@ant-design/icons";

import styles from "./index.module.scss";

const languages = [
  { key: "en", code: "EN", name: "English" },
  { key: "de", code: "DE", name: "Deutsch" },
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const { token } = theme.useToken();

  // The detector can report a regional tag such as "en-US", so fall back to
  // the resolved language before matching it against the supported list.
  const active = i18n.resolvedLanguage || i18n.language || "en";
  const current =
    languages.find(({ key }) => active.startsWith(key)) ?? languages[0];

  // Dropdown styles its own menu rather than reading Menu's tokens, and it
  // paints the selected row in colorPrimary with normal weight. Select marks
  // its selected option with plain text at strong weight instead. Both are set
  // on the label, where an inline style outranks the stylesheet.
  const items = languages.map(({ key, name }) => {
    const selected = key === current.key;

    return {
      key,
      label: (
        <span
          style={
            selected
              ? { color: token.colorText, fontWeight: token.fontWeightStrong }
              : undefined
          }
        >
          {name}
        </span>
      ),
      onClick: () => i18n.changeLanguage(key),
    };
  });

  return (
    <Dropdown
      menu={{ items, selectedKeys: [current.key] }}
      trigger={["click"]}
      placement="bottomRight"
      classNames={{ root: styles.menu }}
      styles={{
        root: {
          "--language-selected-bg": token.controlItemBgActive,
        } as React.CSSProperties,
      }}
    >
      <Button type="text" icon={<GlobalOutlined />}>
        {current.code}
      </Button>
    </Dropdown>
  );
};

export default LanguageSwitcher;
